import InvitationMessageSchema, {
  InvitationMessageJSON,
} from "legal-entities/invitations/messages/_schema/invitation-message-schema";
import PrimitiveValueObject from "_framework/entities/values/primitive-value-object";
import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";

export default class InvitationMessage extends PrimitiveValueObject<InvitationMessage, string, InvitationMessageJSON> {
  public static fromJSON(data: InvitationMessageJSON | null | undefined): InvitationMessage | null | undefined {
    if (isNullOrUndefined(data)) return data;
    return new InvitationMessage(InvitationMessageSchema.deserialize(data));
  }

  public constructor(public readonly value: string) {
    super(value);
  }

  public toJSON(): InvitationMessageJSON {
    return InvitationMessageSchema.serialize(this.value);
  }

  public valueOf(): string {
    return this.value;
  }

  public isEqualTo(other: InvitationMessage | null | undefined): boolean {
    if (!other) return false;
    return this.value === other.value;
  }

  public toString(): string {
    return `InvitationMessage { value: ${this.value} }`;
  }
}

export class InvalidInvitationMessageError extends Error {
  constructor(value: string) {
    super(`Invalid invitation message: ${value}`);
  }
}
